export default {"src":"/_next/static/media/logo.c29c1803.svg","height":34,"width":43,"blurWidth":0,"blurHeight":0};